import React from "react";
import {Box, Paper, Stack, Typography} from "@mui/material";
import {idDaSecao} from "../sistemaPagina";

// A barra superior é fixa: a rolagem até a seção para abaixo dela.
export const MARGEM_DA_ROLAGEM = 88;

export default function SecaoCard({id, titulo, subtitulo, chip, acoes, semCartao = false, children}) {
    const cabecalho = (
        <Stack direction="row" flexWrap="wrap" useFlexGap gap={1.5} alignItems="center" sx={{px: semCartao ? 0 : {xs: 2, md: 3}, pt: semCartao ? 0 : 2.5, pb: 2}}>
            <Box sx={{flex: '1 1 280px', minWidth: 0}}>
                <Typography variant="h6" component="h2" fontWeight={700}>{titulo}</Typography>
                {subtitulo ? <Typography variant="body2" color="text.secondary">{subtitulo}</Typography> : null}
            </Box>
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
                {chip}
                {acoes}
            </Stack>
        </Stack>
    );

    if (semCartao) {
        return (
            <Box component="section" id={idDaSecao(id)} aria-label={titulo} sx={{scrollMarginTop: MARGEM_DA_ROLAGEM}}>
                {cabecalho}
                {children}
            </Box>
        );
    }

    return (
        <Paper component="section" id={idDaSecao(id)} aria-label={titulo} variant="outlined" sx={{scrollMarginTop: MARGEM_DA_ROLAGEM}}>
            {cabecalho}
            <Box sx={{px: {xs: 2, md: 3}, pb: 3}}>{children}</Box>
        </Paper>
    );
}
